import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { USER_PROFILE } from '../../../../_models/user.model';
import { AppSettingService } from '../../../../_services/_appSetting/app-setting.service';
import { LocalService } from '../../../../_services/_storage/local.service';

@Component({
    selector: 'lokos-header',
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss',
    standalone: false
})
export class HeaderComponent implements OnInit {
    theme!: string;
    userRoles: string[] | any = this.localService.get('userRoles') || [];
    userProfile: USER_PROFILE | any = this.localService.get('userProfile');
    isProduction = environment.production;

    constructor (private appSettingService: AppSettingService, private localService: LocalService) { }

    ngOnInit (): void {
        this.appSettingService.appTheme$.subscribe((theme) => this.theme = theme);
    }
}
